import { APIModel } from "app/state/api";
import { ApiCallModel } from "app/state/api/interfaces";

export const DataHubOverviewStats: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/overview-stats/{transactionTypeCode}`
  ),
};

export const DataHubLocations: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/locations-stats/{transactionTypeCode}`
  ),
};

export const DataHubLocationsMap: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/locations-map/{transactionTypeCode}`
  ),
};

export const DataHubSDGs: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/sdgs/{transactionTypeCode}`
  ),
};

export const DataHubOrganisationsNetwork: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/organisations-network/{transactionTypeCode}`
  ),
};

export const DataHubImpactResults: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/explorer/general/impact-results`),
};

export const DataHubBudgetBySector: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/budget-by-sector/{years}`
  ),
};

export const DataHubPartnersNetwork: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/organisation/{code}/partners/{transactionTypeCode}`
  ),
};
